const megaPop = data => {
  const round = num => Math.round(num * 100) / 100
  const themes = [
    'Facilities',
    'Policies, Resources & Efficiency',
    'Pride',
    'Compensation, Benefits & Work/Life Balance',
    'Senior Leadership',
    'Shared Governance',
    'Faculty, Administration & Staff Relations',
    'Teaching Environment',
    'Respect & Appreciation',
    'Fairness',
    'Job Satisfaction/Support',
    'Supervisors/Department Chairs',
    'Professional Development',
    'Collaboration',
    'Communication',
    'UA Custom Statements',
  ]
  const themer = []

  const werk = (data, theme) =>
    data
      .filter(d => d.topic === theme)
      .map(node => ({
        q: node.q,
        question: node.question,
        mean: eval(node.mean) || 0,
        SUG_mean: eval(node.SUG_mean) || 0,
        SA: eval(node.SA) || 0,
        SUG_SA: eval(node.SUG_SA) || 0,
        A: eval(node.A) || 0,
        SUG_A: eval(node.SUG_A) || 0,
        U: eval(node.U) || 0,
        SUG_U: eval(node.SUG_U) || 0,
        D: eval(node.D) || 0,
        SUG_D: eval(node.SUG_D) || 0,
        SD: eval(node.SD) || 0,
        SUG_SD: eval(node.SUG_SD) || 0,
        UA_mean: eval(node.UA_mean) || 0,
        UA_SA: eval(node.UA_SA) || 0,
        UA_A: eval(node.UA_A) || 0,
        UA_U: eval(node.UA_U) || 0,
        UA_D: eval(node.UA_D) || 0,
        UA_SD: eval(node.UA_SD) || 0,
        UA2_mean: eval(node.UA2_mean) || 0,
        UA2_SA: eval(node.UA2_SA) || 0,
        UA2_A: eval(node.UA2_A) || 0,
        UA2_U: eval(node.UA2_U) || 0,
        UA2_D: eval(node.UA2_D) || 0,
        UA2_SD: eval(node.UA2_SD) || 0,
        topic: node.topic,
      }))
      .reduce(
        (c, n, currentIndex, array) => ({
          ...n,
          q: null,
          question: null,
          mean:
            currentIndex == array.length - 1
              ? round((c.mean + n.mean) / array.length)
              : c.mean + n.mean,
          SUG_mean:
            currentIndex == array.length - 1
              ? round((c.SUG_mean + n.SUG_mean) / array.length)
              : c.SUG_mean + n.SUG_mean,
          SA:
            currentIndex == array.length - 1
              ? round((c.SA + n.SA) / array.length)
              : c.SA + n.SA,
          SUG_SA:
            currentIndex == array.length - 1
              ? round((c.SUG_SA + n.SUG_SA) / array.length)
              : c.SUG_SA + n.SUG_SA,
          A:
            currentIndex == array.length - 1
              ? round((c.A + n.A) / array.length)
              : c.A + n.A,
          SUG_A:
            currentIndex == array.length - 1
              ? round((c.SUG_A + n.SUG_A) / array.length)
              : c.SUG_A + n.SUG_A,
          U:
            currentIndex == array.length - 1
              ? round((c.U + n.U) / array.length)
              : c.U + n.U,
          SUG_U:
            currentIndex == array.length - 1
              ? round((c.SUG_U + n.SUG_U) / array.length)
              : c.SUG_U + n.SUG_U,
          D:
            currentIndex == array.length - 1
              ? round((c.D + n.D) / array.length)
              : c.D + n.D,
          SUG_D:
            currentIndex == array.length - 1
              ? round((c.SUG_D + n.SUG_D) / array.length)
              : c.SUG_D + n.SUG_D,
          SD:
            currentIndex == array.length - 1
              ? round((c.SD + n.SD) / array.length)
              : c.SD + n.SD,
          SUG_SD:
            currentIndex == array.length - 1
              ? round((c.SUG_SD + n.SUG_SD) / array.length)
              : c.SUG_SD + n.SUG_SD,
          UA_mean:
            currentIndex == array.length - 1
              ? round((c.UA_mean + n.UA_mean) / array.length)
              : c.UA_mean + n.UA_mean,
          UA_SA:
            currentIndex == array.length - 1
              ? round((c.UA_SA + n.UA_SA) / array.length)
              : c.UA_SA + n.UA_SA,
          UA_A:
            currentIndex == array.length - 1
              ? round((c.UA_A + n.UA_A) / array.length)
              : c.UA_A + n.UA_A,
          UA_U:
            currentIndex == array.length - 1
              ? round((c.UA_U + n.UA_U) / array.length)
              : c.UA_U + n.UA_U,
          UA_D:
            currentIndex == array.length - 1
              ? round((c.UA_D + n.UA_D) / array.length)
              : c.UA_D + n.UA_D,
          UA_SD:
            currentIndex == array.length - 1
              ? round((c.UA_SD + n.UA_SD) / array.length)
              : c.UA_SD + n.UA_SD,
          UA2_mean:
            currentIndex == array.length - 1
              ? round((c.UA2_mean + n.UA2_mean) / array.length)
              : c.UA2_mean + n.UA2_mean,
          UA2_SA:
            currentIndex == array.length - 1
              ? round((c.UA2_SA + n.UA2_SA) / array.length)
              : c.UA2_SA + n.UA2_SA,
          UA2_A:
            currentIndex == array.length - 1
              ? round((c.UA2_A + n.UA2_A) / array.length)
              : c.UA2_A + n.UA2_A,
          UA2_U:
            currentIndex == array.length - 1
              ? round((c.UA2_U + n.UA2_U) / array.length)
              : c.UA2_U + n.UA2_U,
          UA2_D:
            currentIndex == array.length - 1
              ? round((c.UA2_D + n.UA2_D) / array.length)
              : c.UA2_D + n.UA2_D,
          UA2_SD:
            currentIndex == array.length - 1
              ? round((c.UA2_SD + n.UA2_SD) / array.length)
              : c.UA2_SD + n.UA2_SD,
        }),
        {
          mean: 0,
          SUG_mean: 0,
          SA: 0,
          SUG_SA: 0,
          A: 0,
          SUG_A: 0,
          U: 0,
          SUG_U: 0,
          D: 0,
          SUG_D: 0,
          SD: 0,
          SUG_SD: 0,
          UA_mean: 0,
          UA_SA: 0,
          UA_A: 0,
          UA_U: 0,
          UA_D: 0,
          UA_SD: 0,
          UA2_mean: 0,
          UA2_SA: 0,
          UA2_A: 0,
          UA2_U: 0,
          UA2_D: 0,
          UA2_SD: 0,
        }
      )

  themes.forEach(theme => {
    themer.push(werk(data, theme))
  })

  return themer
}

// const bigC = bData.sort((a, b) => a.mean - b.mean)

export default megaPop



// WEBPACK FOOTER //
// ./src/components/megaPop.js